import { faCheck, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import Text, { TextKind } from './Text';

const StyledCheckItems = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const StyledCheckItem = styled.li`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const CheckItems = ({
  testId = 'checkitems',
  children,
}: {
  testId?: string;
  children: React.ReactNode;
}) => <StyledCheckItems data-testid={testId}>{children}</StyledCheckItems>;

export const CheckItem = ({
  testId = 'checkitem',
  text,
  icon = faCheck,
}: {
  testId?: string;
  text: string;
  icon?: IconDefinition;
}) => (
  <StyledCheckItem data-testid={testId}>
    <FontAwesomeIcon icon={icon} />
    <Text kind={TextKind.BodyS}>{text}</Text>
  </StyledCheckItem>
);
